module.exports = __webpack_public_path__ + "media/images/home_ic-142f9d82561d06cab8076c7a143f00a7.svg";